var React = require('react');

function CancelInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 1L20 20","stroke":"white","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M1 1L20 20","stroke":"white","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M20 1L1 20","stroke":"white","strokeWidth":"2","key":2}),React.createElement("path",{"d":"M20 1L1 20","stroke":"white","strokeWidth":"2","key":3})]);
}

CancelInline.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = CancelInline;

CancelInline.default = CancelInline;
